import React from 'react';

interface Category {
  id: string;
  name: string;
  isActive?: boolean;
}

interface Props {
  categories: Category[];

  newCategoryName: string;

  setNewCategoryName: (
    value: string
  ) => void;

  creatingCategory: boolean;

  handleCreateCategory: () => Promise<void>;

  handleToggleCategory: (
    categoryId: string,
    currentStatus: boolean
  ) => Promise<void>;
}

const CategoriesSection: React.FC<Props> = ({
  categories,
  newCategoryName,
  setNewCategoryName,
  creatingCategory,
  handleCreateCategory,
  handleToggleCategory
}) => {

  return (

    <>

      <div className="mb-10">

        <h1 className="text-4xl font-bold">

          Categorias

        </h1>

        <p className="text-slate-400 mt-2">

          Gerenciamento das categorias globais.

        </p>

      </div>

      <div className="bg-[#0f172a] border border-white/10 rounded-2xl p-6 mb-8">

  <h2 className="text-xl font-bold text-white mb-4">

    Categorias Globais

  </h2>

  <div className="flex gap-3 mb-6">

  <input

    type="text"

    value={newCategoryName}

    onChange={(e) =>

      setNewCategoryName(
        e.target.value
      )

    }

    placeholder="Nova categoria global"

    className="flex-1 bg-[#020817] border border-white/10 rounded-xl px-4 py-3 text-white outline-none"

  />

  <button

    onClick={handleCreateCategory}

    disabled={creatingCategory}

    className="px-5 py-3 rounded-xl bg-purple-600 hover:bg-purple-700 transition-all text-white font-semibold disabled:opacity-50"

  >

    {creatingCategory

      ? 'Criando...'

      : 'Criar'}

  </button>

</div>

  <div className="flex flex-wrap gap-3">

    {categories.length === 0 && (
      <p className="py-4 text-sm text-slate-400">Nenhuma categoria global criada.</p>
    )}

    {categories.map((category) => (

  <div

    key={category.id}

    className="p-4 rounded-xl bg-purple-500/10 border border-purple-500/20"

  >

    <div className="flex items-center justify-between gap-4">

      <div>

        <p className="text-purple-300 font-medium">

          {category.name}

        </p>

        <p className="text-xs text-gray-400 mt-1">

          {category.isActive

            ? 'Ativa'

            : 'Inativa'}

        </p>

      </div>

      <button

        onClick={() =>

          handleToggleCategory(

            category.id,

            category.isActive ?? true

          )

        }

        className={`px-3 py-2 rounded-lg text-sm transition-all ${
          category.isActive

            ? 'bg-red-500/10 text-red-400 border border-red-500/20'

            : 'bg-green-500/10 text-green-400 border border-green-500/20'
        }`}

      >

        {category.isActive

          ? 'Desativar'

          : 'Ativar'}

      </button>

    </div>

  </div>

))}

  </div>

</div>

    </>

  );

};

export default CategoriesSection;
